module.exports = __webpack_public_path__ + "img/Map@2x.d96e6ab5.png";